import { createSlice } from '@reduxjs/toolkit';

const initialState = '';

const filtersSlice = createSlice({
  name: 'filters',
  initialState: initialState,
  reducers: {
    filterNumbers: (state, action) => {
      return state, action.payload;
    },
  },
});

export const { filterNumbers } = filtersSlice.actions;
export const filtersReducer = filtersSlice.reducer;